<template>
  <div class="select-experience" :class="{ 'dark': darkMode, 'light': !darkMode }">
    <div class="experiences container-width">
      <div class="experience"
      v-for="experience in visibleExperiences"
      :key="experience.id"
      :class="{ 'active': isExperienceSelected(experience) }">
                   <div @click="experienceAction(experience)">
                          <div class="experience-header flex justify-between mb-xs">
                           <span
                             class="title">{{ experience.title }}</span>
                          </div>
                             <div class="experience-container">
                              <div class="image">
                                 <img class="w-100"
                                 :src="experience.imageUrl"
                                :alt="experience.title" />
                              </div>
                              <div class="experience-bottom">
                                <span class="description f6">
                                  {{ experience.description }}
                                </span>
                                <div v-if="getGroupSizeIconCount(experience) <= 8" class="experience-bottom">
                               MAX PLAYERS:
                               <template v-for="index in getGroupSizeIconCount(experience)">
                                 <svg :key="index"
                                 class="member">
                                 <use xlink:href="#icon-person-alt"></use>
                               </svg>
                              </template>
                            </div>
                            <div v-else class="experience-bottom">
                              <template>
                                <p class="maxPlayers" >
                                  Max players:
                                  <svg
                                  class="member">
                                  <use xlink:href="#icon-person-alt"></use>
                                </svg>
                                up to {{ getGroupSizeIconCount(experience) }}
                              </p>
                            </template>
                          </div>
                       </div>
                           </div>
                          </div>
                          <div class="experience-tiers">
                          <div v-for="tier in experience.tiers" :key="tier.id" class="experience-tiers-grid">
                            <div class="experience-tiers-row experience-tiers-price" v-if="!isOrganizationEducation">
                              {{ toLocationCurrency(tier.price, settings.location) }}
                            </div>
                            <div v-else class="experience-tiers-row experience-tiers-price" >
                              {{ $t('free') }}
                            </div>
                            <div class="experience-tiers-row experience-tiers-length">
                              {{ tier.length }} {{ $t('Min') }}
                            </div>
                          </div>
                        </div>
                        </div>
                        <div class="experience">
                        </div>
                      </div>
                      <div class="experience-arrow left"
                 :class="{ 'enabled': showLeftArrow, 'disabled': hideArrow }"
                 @click="previousBatch()"
                 >
                 <img src="../../assets/icons.svg#icon-chevron-left-gradient"
                   alt="*">
               </div>
               <div class="experience-arrow right"
                       :class="{ 'enabled': this.showRightArrow, 'disabled': hideArrow }"
                           @click="nextBatch()"
                          >
                        <img src="../../assets/icons.svg#icon-chevron-right-gradient"
                          alt="*">
                      </div>
                    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import LocationHelper from '@/core/shared/helpers/LocationHelper';

@Component({
  props: {
    experiences: {
      type: Array,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
    numberOfPlayers: {
      type: Number,
      required: true,
      default: 0,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
    widget: {
      type: Object,
    },
    settings: {
      type: Object,
    },
    isOrganizationEducation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
  },
})
export default class ExperienceSelector extends Vue {
  showLeftArrow = false;
  showRightArrow = false;
  hideArrow = false;
  experiencePage = 1;
  visibleExperiences = [];

  get location () {
    return this.settings.location;
  }

  getGroupSizeIconCount (experience) {
    return experience.maxPeoplePerStation;
  }

  async created () {
    this.booking.location.id = this.settings.location.id;
    this.booking.bookingStationTimes[0].experience.id = this.experiences[0].id;

    this.visibleExperiences = this.experiences.slice(0, 6);
    if (this.experiences.length <= 6) {
      this.hideArrow = true;
    }

    if (this.experiences && this.experiences.length > 6) {
      this.showRightArrow = true;
    }
  }

  isExperienceSelected (experience) {
    return experience.id === this.booking.bookingStationTimes[0].experience.id;
  }

  onBookingUpdate (booking) {
    this.booking = booking;
  }

  displayExperiences () {
    const startIndex = this.experiencePage * 6 - 6;
    const endIndex = startIndex + 6;
    const items = this.experiences;

    const currentBatch = items.slice(startIndex, endIndex);

    this.visibleExperiences = currentBatch;
  }

  nextBatch () {
    const maxBatches = Math.ceil(this.experiences.length / 6);
    this.experiencePage++;
    this.showLeftArrow = true;
    if (this.experiencePage === maxBatches) {
      this.displayExperiences();
      this.showRightArrow = false;
    } else if (this.experiencePage < maxBatches) {
      this.displayExperiences();
    } else {
    }
  }

  previousBatch () {
    this.experiencePage--;
    this.showRightArrow = true;
    if (this.experiencePage === 1) {
      this.displayExperiences();
      this.showLeftArrow = false;
    } else if (this.experiencePage > 1) {
      this.displayExperiences();
    }
  }

  toLocationCurrency (number, location) {
    return LocationHelper.formatApiPriceIntoLocationCurrency(location, number);
  }

  experienceAction (experience) {
    this.booking.bookingStationTimes[0].experience.id = experience.id;
    this.$emit('onSelect', experience);
  }
}
</script>

<style scoped lang="postcss">
@import "core/shared/styles";

.experiences {
  display: grid;
  z-index: 5;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 20px;
  padding-top: var(--spacingMd);

  @media (--tablet) {
    gap: 80px;
  }
}

@media (orientation: portrait) {
  .experiences {
    grid-template-columns: repeat(1, 1fr);
    }
  .experience-tiers {
    right: 0px !important;
  }
}

.experiences .experience {
  position: relative;
}

.experience {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  & .experience-header {
    flex-direction: column;

    @media (--tablet) {
      flex-direction: row;
    }
  }

  .title {
    @apply --f5;
    font-size: 14px;
    color: #293E5D;

    @media (--tablet) {
      font-size: 18px;
    }
  }

  .member {
    fill: #879AB2;
    width: 16px;
    height: 18px;
    margin-right: 4px;
    margin-bottom: -5px;

    @media(--tablet) {
      margin-right: 0;
      margin-left: 4px;
    }
  }

  .description {
    font-size: 1em;
    font-family: 'Open Sans', sans-serif;
  }

  .image {
    border: 1px solid #879AB2;
    border-radius: 3px;
    position: relative;
    cursor: pointer;
    display: flex;

    img {
      aspect-ratio: 280 / 180;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      transition: opacity .15s ease-in;
    }

    &:hover {
      border-color: var(--colorSBRedFlat);

      &:after {
        opacity: 0.5;
      }
    }
  }

  &.active .image {
    border-color: var(--colorSBRedFlat);

    &:after {
      opacity: 1;
    }
  }
}

.section-title {
  @apply --f2;
  font-size: 26px;
  z-index: 5;
  font-weight: 800;
  line-height: 28px;
  margin-top: 0;
  margin-bottom: var(--spacingSm);

  @media (--tablet) {
    font-size: 35px;
    margin-bottom: var(--spacingMd);
  }
}

.section-title {
  @apply --f2;
  font-size: 26px;
  z-index: 5;
  font-weight: 800;
  line-height: 28px;
  margin-top: 0;
  margin-bottom: var(--spacingSm);

  @media (--tablet) {
    font-size: 35px;
    margin-bottom: var(--spacingMd);
  }
}

.experience-arrow {
  position: absolute;
  pointer-events: none;
  transition: opacity 0.3s ease;
  cursor: pointer;
  filter: opacity(0.7);
  filter: grayscale(70%);

  &.left {
    left: 12em;
    bottom: 70%;
  }

  &.right {
    left: 165em;
    bottom: 70%;
  }

  &.enabled {
    pointer-events: auto;
    filter: opacity(0.6);

    &:hover {
      filter: opacity(1);
    }
  }
  &.disabled {
    display:none;
  }

  & img {
    width: 80px;
    height: 80px;
  }
}

.experience-bottom {
  margin-top: 5px;
  margin-right: 5px;
  font-family: 'Open Sans', sans-serif;
}

maxPlayers {
  font-family: 'Open Sans', sans-serif;
}
.experience-container {
  padding: 10px;
  border-color: gray;
  background-color: #F7F8F8;
  border-width: 1px;
  border-style: solid;
  opacity: 0.7;
}

.experience-tiers {
  position: absolute;
  width: 100px;
  right: -50px;
  top: 30px;
}

.experience-tiers-grid {
  grid-template-columns: repeat(2, 1fr);
  display: grid;
  align-items: start;
}

.experience-tiers-row {
  padding-top: 10px;
  padding-bottom: 10px;
  border: darkgray solid 1px;
  text-align: center;
  border-radius: 5px;
  margin-top: 12.3px;
  border-radius: 0;
  margin-left: -1px;
  align-items: start;
}

.experience-tiers-price {
  background-color: #F7F8F8;
  color: #1F1E1E;
  font-size: small;
  align-items: start;

}

.experience-tiers-length {
  background-color: #F7F8F8;
  color: #1F1E1E;
  font-size: small;
  transform: translate(0px, 5px);
}

.select-experience.dark .experiences .experience .experience-header .title {
  color: #F7F8F8;
  }

  .select-experience.dark  .member {
    fill: #F7F8F8;
  }

  .select-experience.dark .experiences .experience .experience-container  {
    border-color: gray;
    background-color: #1F1E1E;
  }

  .select-experience.dark .experiences .experience .experience-tiers .experience-tiers-grid .experience-tiers-row {
    background-color: #1F1E1E;
    color: #F7F8F8;
    font-size: small;
  }

  .select-experience.dark .experiences .experience .experience-container .experience-bottom {
    color: #F7F8F8;
    font-size: 1em;
    font-family: 'Open Sans', sans-serif;
  }

</style>
